import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'clear']

  connect() {
    this.rows   = Array.from(this.element.querySelectorAll('.g-row'))
    this.labels = this.rows.map(row => this.normalize(row.dataset.label || ''))
    this.timer  = null
  }

  filter() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.apply(), 120)
  }

  apply() {
    const query = this.normalize(this.inputTarget.value.trim())
    if (this.hasClearTarget) this.clearTarget.hidden = query === ''
    this.rows.forEach((row, i) => {
      const show = query === '' || this.labels[i].includes(query)
      row.classList.toggle('d-none', !show)
    })
  }

  clear() {
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.apply()
  }

  normalize(text) {
    return text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  }
}
